(function ($, window, document, undefined) {

Forms = ( function() {

	function Constructor() {
		var timer;

		function tagsUpdate( response ) {
			var typesArr = [];
			var ecosystemsArr = [];
			var categoriesArr = [];

			$( '.tags-types .created-tags span' ).each( function() {
				typesArr.push( $( this ).data( 'tag' ) );
			} );

			$( '.tags-ecosystems .created-tags span' ).each( function() {
				ecosystemsArr.push( $( this ).data( 'tag' ) );
			} );

			$( '.tags-cats .created-tags span' ).each( function() {
				categoriesArr.push( $( this ).data( 'tag' ) );
			} );

			response.types.forEach((item, i) => {
				if( typesArr.indexOf( item ) === -1 ) {
					$( '.tags-types .created-tags' ).append( '<span data-tag="' + item + '">' + item + '</span>' );
				}
			});

			response.ecosystems.forEach((item, i) => {
				if( ecosystemsArr.indexOf( item ) === -1 ) {
					$( '.tags-ecosystems .created-tags' ).append( '<span data-tag="' + item + '">' + item + '</span>' );
				}
			});

			response.categories.forEach((item, i) => {
				if( categoriesArr.indexOf( item ) === -1 ) {
					$( '.tags-cats .created-tags' ).append( '<span data-tag="' + item + '">' + item + '</span>' );
				}
			});

		}

		this.start = function ( ) {
			// WP Media Uploader if logged in
			var custom_uploader;

			$( '.upload_image_button' ).click(function(e) {
				e.preventDefault();

				var upload_button = $( this );

				//Extend the wp.media object
				custom_uploader = wp.media.frames.file_frame = wp.media( {
					title: 'Choose Image',
					button: {
						text: 'Choose Image'
					},
					multiple: false
				} );

				//When a file is selected, grab the URL and set it as the text field's value
				custom_uploader.on( 'select', function() {
					var attachment = custom_uploader.state().get( 'selection' ).first().toJSON();
					upload_button.siblings( 'input[type="text"]' ).val( attachment.url );
				});

				//Open the uploader dialog
				custom_uploader.open();

			});

			// Add Portfolio Form Submission
			$( '#add-portfolio .tags input' ).keyup( function ( e ) {
				e.preventDefault();
				var input = $( this );
				var search = input.val();

				if ( timer ) {
					clearTimeout( timer );
					timer = null;
				}

				timer = setTimeout( function () {
					var split = search.split( ',' );
					if( split.length > 2 ) {
						input.val( split[1] + ',' + split[2] );
					}
				}, 300 );
			} );

			$( '#add-portfolio .tags .created-tags span' ).click( function( e ) {
				e.preventDefault();

				var tag = $( this ).data( 'tag' );
				var input = $( this ).parents( '.tags' ).find( 'input' );

				if( input.val() == '' ) {
					input.val( tag );
				} else {
					var split = input.val().split( ',' );
					if( split.length < 2 ) {
						if( $.inArray( tag, split ) === -1 ) {
							input.val( input.val() + ',' + tag );
						}
					} else {
						if( $.inArray( tag, split ) === -1 ) {
							input.val( split[1] + ',' + tag );
						}
					}
				}
			} );

			$( '#add-portfolio form' ).submit( function( e ) {
				e.preventDefault();

				var fd = new FormData( $( '#add-portfolio #form' )[0] );

				$.ajax({
					url: '/wp-content/themes/arrington/templates/forms/portfolio-form.php',
					type: 'post',
					data: fd,
					contentType: false,
					processData: false,
					success: function( response ) {
						if( response != 0 ) {
							$( '.success' ).addClass( 'submitted' );
							setTimeout( function() {
								$( '.success' ).removeClass( 'submitted' );
								$( '#add-portfolio form' )[0].reset();
								tagsUpdate( response );
							}, 2000 );
						} else {
							console.log( 'error occurred' );
						}
					},
				});
			} );

			// Add Careers Form Submission
			$( '#add-careers .name select' ).change( function() {
				var option = $( this ).find( ':selected' ).data( 'id' );
				$.ajax( {
					method: 'GET',
					url: '/wp-admin/admin-ajax.php',
					data: {
						action: 'get_company_image',
						option: option
					},
					success: function( response ) {
						$( '.logo input' ).val( response );
					}
				} );
			} );

			$( '#add-careers form' ).submit( function( e ) {
				e.preventDefault();

				var fd = new FormData( $( '#add-careers #form' )[0] );

				$.ajax({
					url: '/wp-content/themes/arrington/templates/forms/careers-form.php',
					type: 'post',
					data: fd,
					contentType: false,
					processData: false,
					success: function( response ) {
						if( response != 0 ){
							$( '.success' ).addClass( 'submitted' );
							setTimeout( function() {
								$( '.success' ).removeClass( 'submitted' );
								$( '#add-careers form' )[0].reset();
							}, 2000 );
						} else {
							console.log( 'error occurred' );
						}
					},
				});
			} );

		};

	}
	return new Constructor();

}() );

})(jQuery, window, document);
